export default "__VITE_ASSET__CThcr$j___"